import MilestonesAdapter from './base';

export default class Set extends MilestonesAdapter {
  modelNamePlural = 'sets';
}
